export default "__VITE_ASSET__CiePLUIQ__"